// Styles
import '../scss/index.scss';
import '/vendor/pages-v2/index';

// ================================================
// MODERN INTERACTIONS & ANIMATIONS
// ================================================

$(document).ready(function () {
  // Mobile menu toggle
  $('.header-burger-menu').on('click', function () {
    $('.header-navigations').addClass('active');
    $('body').addClass('hidden');
  });

  $('.header-navigations__close').on('click', function () {
    $('.header-navigations').removeClass('active');
    $('body').removeClass('hidden');
  });

  // Close menu on link click (mobile)
  $('.header-navigations .nav-link').on('click', function () {
    $('.header-navigations').removeClass('active');
    $('body').removeClass('hidden');
  });

  // Header scroll effect
  let lastScroll = 0;
  $(window).on('scroll', function () {
    const currentScroll = $(window).scrollTop();

    if (currentScroll > 50) {
      $('.header-section').addClass('scrolled');
    } else {
      $('.header-section').removeClass('scrolled');
    }

    lastScroll = currentScroll;
  });

  // Scroll animations with Intersection Observer
  const animateOnScroll = () => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const delay = entry.target.dataset.delay || 0;
            setTimeout(() => {
              entry.target.classList.add('animated');
            }, delay * 1000);
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px',
      }
    );

    document.querySelectorAll('[data-animate]').forEach((el) => {
      observer.observe(el);
    });
  };

  // Initialize scroll animations
  animateOnScroll();

  // Smooth scroll for anchor links
  $('a[href^="#"]').on('click', function (e) {
    const target = $(this.getAttribute('href'));
    if (target.length) {
      e.preventDefault();
      $('html, body').animate(
        {
          scrollTop: target.offset().top - 100,
        },
        600,
        'swing'
      );
    }
  });

  // Counter animation for stats
  const animateCounter = (element, target) => {
    let current = 0;
    const increment = target / 50;
    const timer = setInterval(() => {
      current += increment;
      if (current >= target) {
        element.textContent = target + (element.dataset.suffix || '');
        clearInterval(timer);
      } else {
        element.textContent = Math.floor(current) + (element.dataset.suffix || '');
      }
    }, 30);
  };

  // Observe stat numbers
  const statObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !entry.target.classList.contains('counted')) {
          entry.target.classList.add('counted');
          const target = parseInt(entry.target.dataset.count) || 0;
          if (target > 0) {
            animateCounter(entry.target, target);
          }
        }
      });
    },
    { threshold: 0.5 }
  );

  document.querySelectorAll('[data-count]').forEach((el) => {
    statObserver.observe(el);
  });

  // Parallax effect for hero bottles
  $(window).on('mousemove', function (e) {
    const mouseX = (e.clientX / window.innerWidth - 0.5) * 2;
    const mouseY = (e.clientY / window.innerHeight - 0.5) * 2;

    $('.bottle-main').css({
      transform: `translate(${mouseX * 10}px, ${mouseY * 10}px)`,
    });

    $('.bottle-secondary').css({
      transform: `translate(${mouseX * -15}px, ${mouseY * 15}px) rotate(-15deg)`,
    });

    $('.bottle-tertiary').css({
      transform: `translate(${mouseX * 20}px, ${mouseY * -20}px) rotate(15deg)`,
    });
  });

  // Tab functionality
  $('.tab-item').on('click', function () {
    const tab = $(this).data('tab');

    $('.tab-item').removeClass('active');
    $(this).addClass('active');

    // Trigger custom event for tab change
    $(document).trigger('tabChange', [tab]);
  });

  // Ring progress animation
  const ringObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.querySelector('.ring-progress')?.classList.add('animate');
        }
      });
    },
    { threshold: 0.5 }
  );

  document.querySelectorAll('.stat-ring').forEach((el) => {
    ringObserver.observe(el);
  });

  // Create particle effect in hero
  const createParticles = () => {
    const container = document.getElementById('hero-particles');
    if (!container) return;

    for (let i = 0; i < 30; i++) {
      const particle = document.createElement('div');
      particle.className = 'particle';
      particle.style.cssText = `
        position: absolute;
        width: ${Math.random() * 4 + 2}px;
        height: ${Math.random() * 4 + 2}px;
        background: rgba(0, 245, 212, ${Math.random() * 0.5 + 0.1});
        border-radius: 50%;
        left: ${Math.random() * 100}%;
        top: ${Math.random() * 100}%;
        animation: floatParticle ${Math.random() * 10 + 10}s linear infinite;
        animation-delay: ${Math.random() * 5}s;
      `;
      container.appendChild(particle);
    }
  };

  createParticles();

  // Add particle animation to stylesheet
  const style = document.createElement('style');
  style.textContent = `
    @keyframes floatParticle {
      0%, 100% {
        transform: translate(0, 0) scale(1);
        opacity: 0;
      }
      10% {
        opacity: 1;
      }
      50% {
        transform: translate(${Math.random() * 200 - 100}px, ${Math.random() * 200 - 100}px) scale(1.5);
        opacity: 0.8;
      }
      90% {
        opacity: 1;
      }
    }
  `;
  document.head.appendChild(style);

  // Magnetic button effect
  $('.primary-btn, .cta-button').on('mousemove', function (e) {
    const rect = this.getBoundingClientRect();
    const x = e.clientX - rect.left - rect.width / 2;
    const y = e.clientY - rect.top - rect.height / 2;

    $(this).css({
      transform: `translate(${x * 0.1}px, ${y * 0.1}px)`,
    });
  });

  $('.primary-btn, .cta-button').on('mouseleave', function () {
    $(this).css({
      transform: 'translate(0, 0)',
    });
  });

  // Product card tilt effect
  $('.home-product__box, .ha-product__box, .bento-card').on('mousemove', function (e) {
    const rect = this.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width - 0.5;
    const y = (e.clientY - rect.top) / rect.height - 0.5;

    $(this).css({
      transform: `perspective(1000px) rotateX(${y * -5}deg) rotateY(${x * 5}deg) translateY(-12px)`,
    });
  });

  $('.home-product__box, .ha-product__box, .bento-card').on('mouseleave', function () {
    $(this).css({
      transform: 'perspective(1000px) rotateX(0) rotateY(0) translateY(0)',
    });
  });

  // Glow effect following cursor on cards
  $('.home-product__box, .ha-product__box').on('mousemove', function (e) {
    const rect = this.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    $(this).css({
      '--mouse-x': x + 'px',
      '--mouse-y': y + 'px',
    });
  });

  // Scroll progress indicator
  const createScrollProgress = () => {
    const progress = document.createElement('div');
    progress.className = 'scroll-progress';
    progress.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 0%;
      height: 3px;
      background: linear-gradient(90deg, #00f5d4, #9b5de5);
      z-index: 9999;
      transition: width 0.1s linear;
    `;
    document.body.appendChild(progress);

    $(window).on('scroll', function () {
      const scrollTop = $(window).scrollTop();
      const docHeight = $(document).height() - $(window).height();
      const scrollPercent = (scrollTop / docHeight) * 100;
      progress.style.width = scrollPercent + '%';
    });
  };

  createScrollProgress();

  // Hide scroll indicator on scroll
  $(window).on('scroll', function () {
    if ($(window).scrollTop() > 100) {
      $('.scroll-indicator').fadeOut();
    } else {
      $('.scroll-indicator').fadeIn();
    }
  });

  // Marquee pause on hover
  $('.marquee-section').on('mouseenter', function () {
    $('.marquee-track').css('animation-play-state', 'paused');
  });

  $('.marquee-section').on('mouseleave', function () {
    $('.marquee-track').css('animation-play-state', 'running');
  });

  // Newsletter form interaction
  $('.newsletter-input, .ft-form__input').on('focus', function () {
    $(this).closest('.newsletter-form, .ft-form').addClass('focused');
  });

  $('.newsletter-input, .ft-form__input').on('blur', function () {
    $(this).closest('.newsletter-form, .ft-form').removeClass('focused');
  });

  // Typing effect for hero title (optional enhancement)
  const heroTitleElement = document.querySelector('.hero-title .title-line:last-child');
  if (heroTitleElement && heroTitleElement.textContent === 'headerTitle') {
    // This will be replaced by the dynamic content, so we keep it as a placeholder
  }

  console.log('🚀 Modern animations initialized');
});
